import React from 'react';
import { useScoreboard } from './context/ScoreboardContext';
import { useDashboardLanguage } from './context/DashboardLanguageContext';
import { useLanguage } from './context/LanguageContext';
import ImageCarousel from './ImageCarousel';
import { formatClock } from '@rhs/core';

// STAGE 5: the running break is owned by the MatchStore. This overlay is now purely DERIVED:
// it reads breakTimeInSeconds (= ceil(store.breakRemainingMs/1000)) and showBreakOverlay from
// the context, renders the countdown + carousel, applies the red ≤15s styling, and ends the
// break manually via the context endBreak command. The break buzzer + auto-close at 0 fire
// once from the central tick in ScoreboardContext (main window), so the legacy
// breakStartTime/initialBreakTime refs and the setBreakTimeInSeconds-driven countdown are GONE.
const BreakOverlay = ({ isLiveView }) => {
  const { t: dt } = useDashboardLanguage();
  const { t } = useLanguage();
  const {
    showBreakOverlay,
    breakTimeInSeconds,
    endBreak,
    carouselImages,
    breakOverlayImages
  } = useScoreboard();

  const handleStopBreak = () => {
    endBreak();
  };

  if (!showBreakOverlay) return null;

  const timeDisplay = formatClock(breakTimeInSeconds * 1000);

  return (
    <>
      {isLiveView ? (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-1/3 max-w-[60vw] py-6 px-6 flex flex-col items-center">
            <h2 className="font-bold text-black mb-4 text-[4vh]">
              {dt('break.breakTime')}
            </h2>
            <div className={`font-bold mb-4 text-[12vh] ${breakTimeInSeconds <= 15 ? 'text-red-500' : 'text-black'}`}>
              {timeDisplay}
            </div>
            <div className="w-full h-[32vh]">
              <ImageCarousel isLiveView={true} images={breakOverlayImages.length > 0 ? breakOverlayImages : carouselImages} />
            </div>
          </div>
        </div>
      ) : (
        <div className="fixed bottom-16 left-4 w-[180px] flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full p-3 flex flex-col items-center">
            <h2 className="font-bold text-black mb-4 text-lg">
              {t('breakOverlay.breakTime')}
            </h2>
            <div className={`font-bold mb-4 text-3xl ${breakTimeInSeconds <= 15 ? 'text-red-500' : 'text-black'}`}>
              {timeDisplay}
            </div>
            <button
              onClick={handleStopBreak}
              className="px-4 py-2 bg-amber-500 text-black text-base font-bold rounded-lg hover:bg-amber-600 w-full"
            >
              {t('breakOverlay.endBreak')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BreakOverlay;
